import React, { useEffect, useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightLong,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import AggregatesImage from "../assets/Images/AGGREGATES 00.1.jpg";
import CrystalSamndImage from "../assets/Images/CRYSTAL SAND 00.3.jpg";
import RMCImage from "../assets/Images/READY MIX CONCRETE.jpg";

const Carousel = () => {
  const carouselRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [dragStartX, setDragStartX] = useState(null);

  const items = [
    {
      image: RMCImage,
      link: "/ready-mix-concrete-suppliers",
      title: "Ready Mix Concrete",
      description:
        "We provide a wide range of mix-designs ranging from M10 to M100 which is a feat that cannot be replicated by anyone in the city.",
    },
    {
      image: CrystalSamndImage,
      link: "/aggregates-and-sand",
      title: "Crystal Sand",
      description: "This is the future of sand as we know it. Welcome to the Future.",
    },
    {
      image: AggregatesImage,
      link: "/aggregate-supplier",
      title: "Aggregates",
      description:
        "Aggregates are the materials used in construction and civil engineering. They include sand, gravel, crushed stone, and recycled concrete.",
    },
  ];

  const move = (direction) => {
    if (buttonDisabled) return;
    setButtonDisabled(true);
    setTimeout(() => setButtonDisabled(false), 800);
    setCurrentIndex((prevIndex) =>
      direction === "next"
        ? (prevIndex + 1) % items.length
        : (prevIndex - 1 + items.length) % items.length
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const translateValue = -currentIndex * (isMobile ? 100 : 80);
    if (carouselRef.current) {
      carouselRef.current.style.transform = `translateX(${translateValue}%)`;
    }
  }, [currentIndex, isMobile]);

  useEffect(() => {
    const interval = setInterval(() => move("next"), 5000); // auto scroll every 5 seconds
    return () => clearInterval(interval);
  }, []);

  const handleMouseMove = (event) => {
    const rect = carouselRef.current.getBoundingClientRect();
    const cursorDiameter = 8 * 16;
    setPosition({
      x: event.clientX - rect.left - cursorDiameter / 2,
      y: event.clientY - rect.top - cursorDiameter / 2,
    });
  };

  const handleMouseEnter = () => setVisible(true);
  const handleMouseLeave = () => setVisible(false);

  const handleDragStart = (e) => {
    setDragStartX(e.clientX);
  };

  const handleDragEnd = (e) => {
    if (dragStartX !== null) {
      const diff = e.clientX - dragStartX;
      if (diff > 50) move("prev");
      else if (diff < -50) move("next");
    }
    setDragStartX(null);
  };

  return (
    <div className="product-cars">
      <div className="carousel__wrapper">
        <div className="carousel__nav">
          <div className="carousel__nav__item" onClick={() => move("prev")}> <FontAwesomeIcon icon={faChevronLeft} size="lg" /></div>
          <div className="carousel__nav__item" onClick={() => move("next")}> <FontAwesomeIcon icon={faChevronRight} size="lg" /></div>
        </div>

        <div className="carousel" ref={carouselRef} onMouseDown={handleDragStart} onMouseUp={handleDragEnd}>
          {items.map((item, index) => (
            <div
              key={index}
              className="carousel__item"
              onMouseMove={handleMouseMove}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Link to={item.link}>
                <img src={item.image} alt={item.title} className="inner-img" style={{ width: isMobile ? '90%' : '100%' }} />
                <div className="carousel__text">
                  <h3 className="text-md lg:text-3xl xl:text-7xl">{item.title}</h3>
                  <p className="text-[16px] md:text-[18px] xl:text-[22px] forSameFonts desc">{item.description}</p>
                </div>
                <div className="carousel__Arrow" style={{ right: isMobile ? '80px' : '20px', bottom: isMobile ? '130px' : '119px' }}>
                  <FontAwesomeIcon icon={faArrowRightLong} />
                </div>
              </Link>
            </div>
          ))}

          {visible && (
            <div className="cursor-wrapper" style={{ position: "absolute", left: `${position.x}px`, top: `${position.y}px`, pointerEvents: "none" }}>
              <div className="cursor-circle">
                <div className="cursor-text">Discover</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
